module.exports = "<img [src]=\"image\" class=\"img-responsive-feed\" />"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/feed/modal-feed/modal-feed.component.html
// module id = ./src/app/shared/feed/modal-feed/modal-feed.component.html
// module chunks = main